<template>
  <new-modal-wrapper
    :widthModal="'80%'"
    :maxWidthModal="500"
    ref="vueUploadErrorModal"
    modal-name="uploadErrorModal"
    :show-close-icon="true"
    :click-to-close="true"
    class="new-upload-error"
    cta-primary-button="uploadErrorChooseImage"
    cta-primary-button-icon-name="camera"
    cta-primary-button-icon-type="icon"
    @cta-action="$refs.ugcImageUploadButton.onUploadClick()"
  >
    <div>
      <div class="new-modal-error-icon">!</div>
      <h2 class="text-center">{{ translations.uploadErrorHeader }}</h2>
      <h5 class="text-center subheader">
        {{ translations.uploadErrorSubHeader }}
      </h5>
      <div class="center-list error-list">
        <p>{{ translations.uploadErrorList2 }}</p>
        <p>{{ translations.uploadErrorList3 }}</p>
        <p>{{ translations.uploadErrorFileSize }}</p>
      </div>
      <p class="text-center error-link">
        <a :href="translations.uploadErrorLink" target="_blank">{{
          translations.uploadErrorLinkText
        }}</a>
      </p>

      <div class="CTA-wrapper row">
        <div class="small-8 large-4 center-column columns">
          <ugc-image-upload
            class="hide"
            ref="ugcImageUploadButton"
            @before-upload="$modal.hide('uploadErrorModal')"
            input-id="error-modal-input"
            :input-label="translations.uploadErrorChooseImage"
            :disableButton="false"
          ></ugc-image-upload>
        </div>
      </div>
    </div>
  </new-modal-wrapper>
</template>

<script>
import newModalWrapper from '@/components/Modals/NewModalWrapper/NewModalWrapper';
import ugcImageUpload from '@/components/UGC/Tray/ImageUpload';

export default {
  name: "NewUploadErrorModal",
  computed: {
    translations() {
      return this.$store.state.translations.data;
    }
  },
  components: {
    ugcImageUpload,
    newModalWrapper
  }
};
</script>
